var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagDa = function SvgFlagDa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag_da_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE2844",
    d: "M0 0h24v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 0h4v16H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 6h24v4H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag_da_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
};
export default SvgFlagDa;